module.exports = __webpack_public_path__ + "img/1s.f9ba8711.png";